import styled from 'styled-components';
import {
	sidebarWidth,
	sidebarBreakpoint,
	totalHeaderHeight,
	topBarHeight,
} from '../../variables';

const getTopPadding = props => {
	// tabs height is approximately 50px
	const tabsHeight = 50;
	if (props.first && props.tabs) return `${totalHeaderHeight + tabsHeight}px`;
	if (props.first) return `${totalHeaderHeight}px`;
	return '0';
};

const getTopPaddingMobile = props => {
	// tabs height is approximately 50px
	const tabsHeight = 50;
	if (props.first && props.tabs) return `${topBarHeight + tabsHeight}px`;
	if (props.first) return `${topBarHeight}px`;
	return '0';
};

const Container = styled.div`
	padding: 0 20px;
	padding-left: ${sidebarWidth + 20 + 'px'};
	padding-top: ${props => getTopPadding(props)};

	@media (max-width: ${sidebarBreakpoint + 'px'}) {
		padding-left: 20px;
		padding-top: ${props => getTopPaddingMobile(props)};
	}
`;

export default Container;



// WEBPACK FOOTER //
// ./src/components/Common/Container/Container.js